// extracted by mini-css-extract-plugin
export var container = "PostCell-module--container--Q2Bcz";
export var cardTitle = "PostCell-module--cardTitle--9JTnv";
export var link = "PostCell-module--link--jrJud";
export var categoryButton = "PostCell-module--categoryButton--66dF0";
export var ellipsis = "PostCell-module--ellipsis--NclJl";